import * as React from "react";
import { TextField, Datagrid, List, BooleanField, BooleanInput, TextInput, Edit, SimpleForm, Toolbar, SaveButton } from 'react-admin';
import { makeStyles } from '@material-ui/core';

const filters = [
    <TextInput label="Search" source="q" alwaysOn />,
];

const useStyles = makeStyles({
    booleanLabel: {
        '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' },
    },
});

const UserEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
);

const UserTitle = props => (
    <span>{props.record ? `${props.record.first_name} ${props.record.last_name}` : 'User'}</span>
);

export const UserList = props => (
    <List {...props} filters={filters}>
        <Datagrid rowClick="edit">
            <TextField source="first_name" />
            <TextField source="last_name" />
            <TextField source="email" />
            <BooleanField looseValue={true} source="is_admin" sortable={false} />
            <BooleanField looseValue={true} source="is_department_admin" sortable={false} />
            <BooleanField looseValue={true} source="is_employee" sortable={false} />
            <BooleanField looseValue={true} source="is_prod_approver" sortable={false} />
            <BooleanField looseValue={true} source="is_dept_approver" sortable={false} />
            <BooleanField looseValue={true} source="new_timesheet_notification" label="Timesheet notifications" sortable={false} />
        </Datagrid>
    </List>
);

export const UserEdit = props => {
    const classes = useStyles();
    return (
        <Edit {...props} title={<UserTitle />} undoable={false}>
            <SimpleForm toolbar={<UserEditToolbar />} redirect="list">
                <TextField source="first_name" label="First name" />
                <TextField source="last_name" label="Last name" />
                <TextField source="email" />
                <BooleanInput source="new_timesheet_notification" label="New timesheet email notifications" className={classes.booleanLabel} />
            </SimpleForm>
        </Edit>
    );
};
